import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateGiftCardMutation = createMutationHook(GiftCardsApiClient.updateGiftCard, {
  mutationKey: ['updateGiftCard'],
})
